import store from "../store/store";
import router from "../router";
import CapturaService from "./CapturaService";
import LoadScriptFilesService from "./LoadScriptFilesService";
import LivenessService from "./LivenessService";

export default class AppService{

  constructor(props) {
    this.$store = store;
    this.$router = router;
    this.capturaService = new CapturaService();
    this.livenessService = new LivenessService();
  }

  buscarDadosLink(){
    return new Promise(((resolve, reject) => {
      if(this.$store.state.id_link){
        resolve();
        return;
      }
      let k = sessionStorage.getItem('k');
      if(!k){
        reject('Link inválido');
        return;
      }
      k = JSON.parse(atob(k));
      if(!k){
        reject('Dados do link inválidos');
        return;
      }
      this.$store.dispatch('setLoadingStatus',true);
      k.origem = window.location.href;
      this.$store.dispatch('recuperarDadosLinkMeuVivo',k)
        .then(() => {
          this.carregarComponentSelefie(true);
          if(this.$store.getters.tipoCaptura === 1){
            this.carregarComponenteDocumento();
          }
          setTimeout(() =>  resolve(),500);
        })
        .catch(e => reject(e));
    }));
  }

  preLoadSelefie(reload = false){
    this.livenessService.preLoad(reload);
  }

  preLoadDocumento(reload = false) {
    let componente_nao_carregado = (typeof window.documento !== 'object' || !(window.documento instanceof window.BrScanSDKDocumento.Documento));

    const COR_PRIMARIA = "#660099";
    const config = {
      tamanhoArquivos: 5,
      enviarTxt: "Fazer upload",
      capturaEmDesktop: true,
      qntTentativasCapManual: false,
      limiteNumeroTentativasErro:3,
      timeoutCaptura:12e4,
      wizzard: true,
      fontFamily: "Roboto",
      corPrimaria: COR_PRIMARIA,
      corPrimary: COR_PRIMARIA,
      corTextCorpo:"#5d5d5d",
      corTextTitle:COR_PRIMARIA,
      corTextButton:"#ffffff",
      previewTitleSideA:null,
      previewTitleSideB:null,
      cdnModelo:"",
      showCancelButton: false,
      isLocalFilesWasOnnx:true,
      isLocalFilePdfJS:true,
      imgAdicionaBtn:"static/doc/images-editadas/adicionaBtn.svg",
      textoPersonalizado: {
        upload_digital_documentos:{
          "subtitle_cnh": "Exporte o documento no formato PDF pela Carteira Digital de Trânsito e envie aqui",
        },
        digital_documents_screen:{
          "button_pre_approuved":{
            "label": "Pré-aprovados",
            "sub_label": "RNE (Registro Nacional de Estrangeiro) <br/> RNM (Registro Nacional Migratório)"
          },
          "button_other_document": {
            "label": "Outros",
            "sub_label": "Passaporte, Carteira de classe, etc."
          }
        },
        capture_instructions_cnh_digital_screen: {
          "title": "Como exportar a CNH Digital",
          "subtitle": "Siga essas etapas no aplicativo Carteira Digital de Trânsito (CDT):",
          "tip_1": "Acesse com sua conta gov.br",
          "tip_2": "Selecione a opção Condutor",
          "tip_3": "Escolha Acessar CNH",
          "tip_4": "Toque no botão Baixar CNH e informe os dados",
          "tip_5": "Exporte o arquivo da sua CNH Digital em PDF",
          "tip_6": "Retorne aqui e selecione Enviar arquivo",
          "buttons": {
            "label": "Enviar arquivo",
            "label_acessar": "Acessar aplicativo CDT"
          }
        },
      }
    };

    if (componente_nao_carregado || reload) {
      window.documento = new window.BrScanSDKDocumento.Documento({ chave: this.$store.state.chave,isLocalFilesWasOnnx: config.isLocalFilesWasOnnx });

      Object.keys(config).forEach(key => {
        window.documento[key] = config[key];
      });
        
      document.documentElement.style.setProperty("--cor-primary", config.corPrimary);
      document.documentElement.style.setProperty("--font-family", config.fontFamily);
      document.documentElement.style.setProperty("--cor-textCorpo", config.corTextCorpo);
      document.documentElement.style.setProperty("--cor-textTitle", '#000000');
      document.documentElement.style.setProperty("--cor-textButton", config.corTextButton);
      
      window.documento.preloadModelos();
      this.$store.dispatch('definirComponenteDocCarregado', true);
    }
  }

  carregarComponenteDocumento(){
    let loadScript =  new LoadScriptFilesService();
    let date = new Date();
    let id =  btoa(`comp-documento-${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`);
    if(document.getElementById(id)){
      return;
    }
    loadScript.head_script('@/../static/doc/brscan-sdk-documento-5.1.15.min.js?v='+Math.random() * 10,id)
        .then(_ => this.preLoadDocumento())
        .catch(() =>  {
          alert('Falha ao carregar componente de captura de documentos, tente novamente mais tarde.')
          this.$router.replace({name: 'Falha'});
        });
  }

  carregarComponentSelefie(reload = false){
    this.livenessService.carregar(reload).catch(() => {
      alert('Falha ao carregar componente de selfie, tente novamente mais tarde.')
      this.$router.replace({name: 'Falha'});
    })
  }


  logarErro(msg){
    let cpf = this.$store.state.cpf;
    let id_link = this.$store.state.id_link;
    this.capturaService.logarErro(msg,cpf,id_link);
  }

  facesDoc(){
    return ['A','B','AB'];
  }

  tipoDOC(){
    return {
      'cnh': 'CNH',
      'rg': 'RG',
      'cin': 'CIN',
      'outro': 'OUTRO',
      'cnhdigital': 'CNHDIGITAL'
    };
  }

  getRouteNameSelfie(){
    return this.livenessService.getRouteName();
  }

  documentosAceitos(documento){
    const documentosMap = {
      RG: ["rg", "dni", "cin"],
      CNH: ["cnh"],
      CNHDIGITAL: ["cnhdig", "cnhdig2022"],
      OUTRO: ["rne", "rnm", "outros"]
    }

    window.documento.documentosAceitos = documentosMap[documento];
  }

}



// WEBPACK FOOTER //
// ./src/services/AppService.js